import React from 'react';

import './../styles/color-swatch.css';

import ColorSwatches from './color-swatches';
import { useFloorMatStore } from '../stores/floor-mat-store';
import { PRODUCTS_MAP } from '../constants/product';

function FloorMatColorSelector() {
  const matColorSwatches = useFloorMatStore(state => state.matColorSwatches);
  const selectedMatColor = useFloorMatStore(state => state.selectedMatColor);
  const setSelectedMatColor = useFloorMatStore(state => state.setSelectedMatColor);
  const borderColorSwatches = useFloorMatStore(state => state.borderColorSwatches);
  const selectedBorderColor = useFloorMatStore(state => state.selectedBorderColor);
  const setSelectedBorderColor = useFloorMatStore(state => state.setSelectedBorderColor);
  const padColorSwatches = useFloorMatStore(state => state.padColorSwatches);
  const selectedPadColor = useFloorMatStore(state => state.selectedPadColor);
  const setSelectedPadColor = useFloorMatStore(state => state.setSelectedPadColor);
  const stitchingColorSwatches = useFloorMatStore(state => state.stitchingColorSwatches);
  const selectedStitchingColor = useFloorMatStore(state => state.selectedStitchingColor);
  const setSelectedStitchingColor = useFloorMatStore(state => state.setSelectedStitchingColor);

  return (
    <>
      {window?.conspire_product?.handle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle && (
        <ColorSwatches
          title="Select Mat Color"
          selectedColor={selectedMatColor}
          setSelectedColor={setSelectedMatColor}
          colors={matColorSwatches}
          showColorName
          className="floor-mats-color-swatch-container"
        />
      )}
      <ColorSwatches
        title="Select Border Color"
        selectedColor={selectedBorderColor}
        setSelectedColor={setSelectedBorderColor}
        colors={borderColorSwatches}
        showColorName
        className="floor-mats-color-swatch-container"
      />
      <ColorSwatches
        title="Select Heel Pad Color"
        selectedColor={selectedPadColor}
        setSelectedColor={setSelectedPadColor}
        colors={padColorSwatches}
        showColorName
        className="floor-mats-color-swatch-container"
      />
      <ColorSwatches
        title="Select Stitching Color"
        selectedColor={selectedStitchingColor}
        setSelectedColor={setSelectedStitchingColor}
        colors={stitchingColorSwatches}
        showColorName
        className="floor-mats-color-swatch-container"
      />
    </>
  )
}

export default FloorMatColorSelector
